import React, { useEffect } from "react";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api"
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Paper, Snackbar, Alert } from "@mui/material";
import { defaultMapOptions } from '../config/gmap-options';

import EventMarker from "../components/event-marker";
import LoadingContainer from "../components/loading-container";
import MarkersCaption from "../components/markers-caption";

const HomePage = () => {
    const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY
    const BASE_URI = process.env.REACT_APP_API_BASE_URI
    const POOLING_INTERVAL = process.env.REACT_APP_POOLING_INTERNAL || 15 * 1000

    const EMPTY_LOCATION = {
        lat: -23.561218,
        lng: -46.632589
    }

    const [currentLocation, setCurrentLocation] = useState(EMPTY_LOCATION)
    const [markersList, setMarkersList] = useState([])
    const [searchParams] = useSearchParams()
    const [errorMessage, setErrorMessage] = useState(null)

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: GOOGLE_API_KEY
    })

    const center = markersList[markersList.length - 1] ? { lat: markersList[markersList.length - 1].location_latitude, lng: markersList[markersList.length - 1].location_longitude } : currentLocation

    function getToken() {
        const tokenValue = searchParams.get('Token')
        const decodedToken = decodeURIComponent(tokenValue)
        return decodedToken
    }

    function getData() {
        getLocation()
        const token = getToken()
        if (token === null || token === "") {
            console.warn("Token not provided")

        }
        else {
            fetch(`${BASE_URI}/emergency-event/trails`, { headers: { "x-pmesp-siopm-token": token } })

                .then((response) => {
                    if (response.ok) {
                        response.json()
                            .then((data) => {
                                if (data.length > 0) {
                                    setMarkersList(data)
                                }
                            })
                    }
                })
                .catch(error => {
                    console.warn(error)
                    setErrorMessage("Erro ao processar a requisição")
                })
        }
    }

    useEffect(() => {
        getData()
        setInterval(() => getData(), POOLING_INTERVAL)
        console.warn("Timer started")

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [POOLING_INTERVAL])

    const handleMessageClose = () => {
        setErrorMessage(null)
    };

    const getLocation = () => {
        navigator.geolocation.getCurrentPosition(updateCurrentLocation);
    }

    const updateCurrentLocation = (position) => {
        const currentLatLong = { lat: position.coords.latitude, lng: position.coords.longitude };
        setCurrentLocation(currentLatLong);
    }

    const mapContainerStyle = { width: '100vw', height: '100vh' }

    return isLoaded ?

        <GoogleMap
            mapContainerStyle={mapContainerStyle}
            center={center}
            zoom={15}
            options={defaultMapOptions}
        >
            <Paper
                component="form"
                sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400, }}
                elevation={5}>

            </Paper>

            <Paper
                component="form"
                sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400, }}
                elevation={5}>
                <MarkersCaption />
            </Paper>

            {
                markersList.map((marker, index) => {
                    return <EventMarker key={index} marker={marker} index={index} listLength={markersList.length} />
                })
            }

            <Snackbar
                open={errorMessage ? true : false}
                autoHideDuration={4000}
                onClose={handleMessageClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
            ><Alert severity="warning">{errorMessage}</Alert>
            </Snackbar>
        </GoogleMap >

        : <LoadingContainer />
}

export default HomePage